import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const PHONE_CONTACT_TYPES = [
    'call', 'phone', 'whatsapp', 'text', 'facetime', 'telegram'
];

/**
 * Checks if a contact link type is phone-related.
 * @param {string} type - The contact link type.
 * @returns {boolean} - True if phone-related, false otherwise.
 */
export function isPhoneContactType(type) {
    return !!type && PHONE_CONTACT_TYPES.includes(type.toLowerCase());
}

/**
 * Formats a phone number into a readable international format (e.g., +65 8465 0756).
 * @param {string} phoneNumber - The phone number to format.
 * @param {string} [defaultCountry='SG'] - The default country code (ISO 3166-1 alpha-2, e.g., 'SG').
 * @returns {string} - The formatted phone number, or the original if invalid.
 */
export function formatPhoneNumber(phoneNumber, defaultCountry = 'SG') {
    if (!phoneNumber) return '';
    try {
        const parsed = parsePhoneNumberFromString(phoneNumber, defaultCountry);
        if (parsed && parsed.isValid()) {
            return parsed.formatInternational();
        }
        return phoneNumber;
    } catch (e) {
        return phoneNumber;
    }
} 